import { useCallback, useState } from "react";
import type { DownloadEvidenceItem } from "../../../services/media/mediaDownloadService";
import { downloadEvidenceBundle } from "../../../services/media/mediaDownloadService";

type EvidenceDownloadAllState = {
  isDownloading: boolean;
  handleDownloadAll: () => void;
};

export function useEvidenceDownloadAll(evidenceItems: DownloadEvidenceItem[]): EvidenceDownloadAllState {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadAll = useCallback(() => {
    if (evidenceItems.length === 0 || isDownloading) {
      return;
    }

    setIsDownloading(true);
    void downloadEvidenceBundle(evidenceItems, "survivor-evidence")
      .finally(() => setIsDownloading(false));
  }, [evidenceItems, isDownloading]);

  return {
    isDownloading,
    handleDownloadAll,
  };
}
